import L, { useEffect as re, useLayoutEffect as Ae, createContext as ge, forwardRef as ve, useState as Z, useRef as A } from "react";
function ce(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function de(e = {}, i = {}) {
  Object.keys(i).forEach((t) => {
    typeof e[t] > "u" ? e[t] = i[t] : ce(i[t]) && ce(e[t]) && Object.keys(i[t]).length > 0 && de(e[t], i[t]);
  });
}
const we = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function I() {
  const e = typeof document < "u" ? document : {};
  return de(e, we), e;
}
const ke = {
  document: we,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function O() {
  const e = typeof window < "u" ? window : {};
  return de(e, ke), e;
}
function De(e) {
  const i = e.__proto__;
  Object.defineProperty(e, "__proto__", {
    get() {
      return i;
    },
    set(t) {
      i.__proto__ = t;
    }
  });
}
class D extends Array {
  constructor(i) {
    typeof i == "number" ? super(i) : (super(...i || []), De(this));
  }
}
function X(e = []) {
  const i = [];
  return e.forEach((t) => {
    Array.isArray(t) ? i.push(...X(t)) : i.push(t);
  }), i;
}
function Se(e, i) {
  return Array.prototype.filter.call(e, i);
}
function Ne(e) {
  const i = [];
  for (let t = 0; t < e.length; t += 1)
    i.indexOf(e[t]) === -1 && i.push(e[t]);
  return i;
}
function Ge(e, i) {
  if (typeof e != "string")
    return [e];
  const t = [], s = i.querySelectorAll(e);
  for (let n = 0; n < s.length; n += 1)
    t.push(s[n]);
  return t;
}
function m(e, i) {
  const t = O(), s = I();
  let n = [];
  if (!i && e instanceof D)
    return e;
  if (!e)
    return new D(n);
  if (typeof e == "string") {
    const r = e.trim();
    if (r.indexOf("<") >= 0 && r.indexOf(">") >= 0) {
      let a = "div";
      r.indexOf("<li") === 0 && (a = "ul"), r.indexOf("<tr") === 0 && (a = "tbody"), (r.indexOf("<td") === 0 || r.indexOf("<th") === 0) && (a = "tr"), r.indexOf("<tbody") === 0 && (a = "table"), r.indexOf("<option") === 0 && (a = "select");
      const d = s.createElement(a);
      d.innerHTML = r;
      for (let l = 0; l < d.childNodes.length; l += 1)
        n.push(d.childNodes[l]);
    } else
      n = Ge(e.trim(), i || s);
  } else if (e.nodeType || e === t || e === s)
    n.push(e);
  else if (Array.isArray(e)) {
    if (e instanceof D)
      return e;
    n = e;
  }
  return new D(Ne(n));
}
m.fn = D.prototype;
function Be(...e) {
  const i = X(e.map((t) => t.split(" ")));
  return this.forEach((t) => {
    t.classList.add(...i);
  }), this;
}
function Ve(...e) {
  const i = X(e.map((t) => t.split(" ")));
  return this.forEach((t) => {
    t.classList.remove(...i);
  }), this;
}
function je(...e) {
  const i = X(e.map((t) => t.split(" ")));
  this.forEach((t) => {
    i.forEach((s) => {
      t.classList.toggle(s);
    });
  });
}
function He(...e) {
  const i = X(e.map((t) => t.split(" ")));
  return Se(this, (t) => i.filter((s) => t.classList.contains(s)).length > 0).length > 0;
}
function Re(e, i) {
  if (arguments.length === 1 && typeof e == "string")
    return this[0] ? this[0].getAttribute(e) : void 0;
  for (let t = 0; t < this.length; t += 1)
    if (arguments.length === 2)
      this[t].setAttribute(e, i);
    else
      for (const s in e)
        this[t][s] = e[s], this[t].setAttribute(s, e[s]);
  return this;
}
function Fe(e) {
  for (let i = 0; i < this.length; i += 1)
    this[i].removeAttribute(e);
  return this;
}
function We(e) {
  for (let i = 0; i < this.length; i += 1)
    this[i].style.transform = e;
  return this;
}
function qe(e) {
  for (let i = 0; i < this.length; i += 1)
    this[i].style.transitionDuration = typeof e != "string" ? `${e}ms` : e;
  return this;
}
function Xe(...e) {
  let [i, t, s, n] = e;
  typeof e[1] == "function" && ([i, s, n] = e, t = void 0), n || (n = !1);
  function r(o) {
    const c = o.target;
    if (!c)
      return;
    const u = o.target.dom7EventData || [];
    if (u.indexOf(o) < 0 && u.unshift(o), m(c).is(t))
      s.apply(c, u);
    else {
      const f = m(c).parents();
      for (let h = 0; h < f.length; h += 1)
        m(f[h]).is(t) && s.apply(f[h], u);
    }
  }
  function a(o) {
    const c = o && o.target ? o.target.dom7EventData || [] : [];
    c.indexOf(o) < 0 && c.unshift(o), s.apply(this, c);
  }
  const d = i.split(" ");
  let l;
  for (let o = 0; o < this.length; o += 1) {
    const c = this[o];
    if (t)
      for (l = 0; l < d.length; l += 1) {
        const u = d[l];
        c.dom7LiveListeners || (c.dom7LiveListeners = {}), c.dom7LiveListeners[u] || (c.dom7LiveListeners[u] = []), c.dom7LiveListeners[u].push({
          listener: s,
          proxyListener: r
        }), c.addEventListener(u, r, n);
      }
    else
      for (l = 0; l < d.length; l += 1) {
        const u = d[l];
        c.dom7Listeners || (c.dom7Listeners = {}), c.dom7Listeners[u] || (c.dom7Listeners[u] = []), c.dom7Listeners[u].push({
          listener: s,
          proxyListener: a
        }), c.addEventListener(u, a, n);
      }
  }
  return this;
}
function Ye(...e) {
  let [i, t, s, n] = e;
  typeof e[1] == "function" && ([i, s, n] = e, t = void 0), n || (n = !1);
  const r = i.split(" ");
  for (let a = 0; a < r.length; a += 1) {
    const d = r[a];
    for (let l = 0; l < this.length; l += 1) {
      const o = this[l];
      let c;
      if (!t && o.dom7Listeners ? c = o.dom7Listeners[d] : t && o.dom7LiveListeners && (c = o.dom7LiveListeners[d]), c && c.length)
        for (let u = c.length - 1; u >= 0; u -= 1) {
          const f = c[u];
          s && f.listener === s || s && f.listener && f.listener.dom7proxy && f.listener.dom7proxy === s ? (o.removeEventListener(d, f.proxyListener, n), c.splice(u, 1)) : s || (o.removeEventListener(d, f.proxyListener, n), c.splice(u, 1));
        }
    }
  }
  return this;
}
function Ke(...e) {
  const i = O(), t = e[0].split(" "), s = e[1];
  for (let n = 0; n < t.length; n += 1) {
    const r = t[n];
    for (let a = 0; a < this.length; a += 1) {
      const d = this[a];
      if (i.CustomEvent) {
        const l = new i.CustomEvent(r, {
          detail: s,
          bubbles: !0,
          cancelable: !0
        });
        d.dom7EventData = e.filter((o, c) => c > 0), d.dispatchEvent(l), d.dom7EventData = [], delete d.dom7EventData;
      }
    }
  }
  return this;
}
function Ue(e) {
  const i = this;
  function t(s) {
    s.target === this && (e.call(this, s), i.off("transitionend", t));
  }
  return e && i.on("transitionend", t), this;
}
function Ze(e) {
  if (this.length > 0) {
    if (e) {
      const i = this.styles();
      return this[0].offsetWidth + parseFloat(i.getPropertyValue("margin-right")) + parseFloat(i.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function Je(e) {
  if (this.length > 0) {
    if (e) {
      const i = this.styles();
      return this[0].offsetHeight + parseFloat(i.getPropertyValue("margin-top")) + parseFloat(i.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function Qe() {
  if (this.length > 0) {
    const e = O(), i = I(), t = this[0], s = t.getBoundingClientRect(), n = i.body, r = t.clientTop || n.clientTop || 0, a = t.clientLeft || n.clientLeft || 0, d = t === e ? e.scrollY : t.scrollTop, l = t === e ? e.scrollX : t.scrollLeft;
    return {
      top: s.top + d - r,
      left: s.left + l - a
    };
  }
  return null;
}
function et() {
  const e = O();
  return this[0] ? e.getComputedStyle(this[0], null) : {};
}
function tt(e, i) {
  const t = O();
  let s;
  if (arguments.length === 1)
    if (typeof e == "string") {
      if (this[0])
        return t.getComputedStyle(this[0], null).getPropertyValue(e);
    } else {
      for (s = 0; s < this.length; s += 1)
        for (const n in e)
          this[s].style[n] = e[n];
      return this;
    }
  if (arguments.length === 2 && typeof e == "string") {
    for (s = 0; s < this.length; s += 1)
      this[s].style[e] = i;
    return this;
  }
  return this;
}
function it(e) {
  return e ? (this.forEach((i, t) => {
    e.apply(i, [i, t]);
  }), this) : this;
}
function st(e) {
  const i = Se(this, e);
  return m(i);
}
function nt(e) {
  if (typeof e > "u")
    return this[0] ? this[0].innerHTML : null;
  for (let i = 0; i < this.length; i += 1)
    this[i].innerHTML = e;
  return this;
}
function rt(e) {
  if (typeof e > "u")
    return this[0] ? this[0].textContent.trim() : null;
  for (let i = 0; i < this.length; i += 1)
    this[i].textContent = e;
  return this;
}
function lt(e) {
  const i = O(), t = I(), s = this[0];
  let n, r;
  if (!s || typeof e > "u")
    return !1;
  if (typeof e == "string") {
    if (s.matches)
      return s.matches(e);
    if (s.webkitMatchesSelector)
      return s.webkitMatchesSelector(e);
    if (s.msMatchesSelector)
      return s.msMatchesSelector(e);
    for (n = m(e), r = 0; r < n.length; r += 1)
      if (n[r] === s)
        return !0;
    return !1;
  }
  if (e === t)
    return s === t;
  if (e === i)
    return s === i;
  if (e.nodeType || e instanceof D) {
    for (n = e.nodeType ? [e] : e, r = 0; r < n.length; r += 1)
      if (n[r] === s)
        return !0;
    return !1;
  }
  return !1;
}
function at() {
  let e = this[0], i;
  if (e) {
    for (i = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (i += 1);
    return i;
  }
}
function ot(e) {
  if (typeof e > "u")
    return this;
  const i = this.length;
  if (e > i - 1)
    return m([]);
  if (e < 0) {
    const t = i + e;
    return t < 0 ? m([]) : m([this[t]]);
  }
  return m([this[e]]);
}
function dt(...e) {
  let i;
  const t = I();
  for (let s = 0; s < e.length; s += 1) {
    i = e[s];
    for (let n = 0; n < this.length; n += 1)
      if (typeof i == "string") {
        const r = t.createElement("div");
        for (r.innerHTML = i; r.firstChild; )
          this[n].appendChild(r.firstChild);
      } else if (i instanceof D)
        for (let r = 0; r < i.length; r += 1)
          this[n].appendChild(i[r]);
      else
        this[n].appendChild(i);
  }
  return this;
}
function ct(e) {
  const i = I();
  let t, s;
  for (t = 0; t < this.length; t += 1)
    if (typeof e == "string") {
      const n = i.createElement("div");
      for (n.innerHTML = e, s = n.childNodes.length - 1; s >= 0; s -= 1)
        this[t].insertBefore(n.childNodes[s], this[t].childNodes[0]);
    } else if (e instanceof D)
      for (s = 0; s < e.length; s += 1)
        this[t].insertBefore(e[s], this[t].childNodes[0]);
    else
      this[t].insertBefore(e, this[t].childNodes[0]);
  return this;
}
function ft(e) {
  return this.length > 0 ? e ? this[0].nextElementSibling && m(this[0].nextElementSibling).is(e) ? m([this[0].nextElementSibling]) : m([]) : this[0].nextElementSibling ? m([this[0].nextElementSibling]) : m([]) : m([]);
}
function ut(e) {
  const i = [];
  let t = this[0];
  if (!t)
    return m([]);
  for (; t.nextElementSibling; ) {
    const s = t.nextElementSibling;
    e ? m(s).is(e) && i.push(s) : i.push(s), t = s;
  }
  return m(i);
}
function pt(e) {
  if (this.length > 0) {
    const i = this[0];
    return e ? i.previousElementSibling && m(i.previousElementSibling).is(e) ? m([i.previousElementSibling]) : m([]) : i.previousElementSibling ? m([i.previousElementSibling]) : m([]);
  }
  return m([]);
}
function ht(e) {
  const i = [];
  let t = this[0];
  if (!t)
    return m([]);
  for (; t.previousElementSibling; ) {
    const s = t.previousElementSibling;
    e ? m(s).is(e) && i.push(s) : i.push(s), t = s;
  }
  return m(i);
}
function mt(e) {
  const i = [];
  for (let t = 0; t < this.length; t += 1)
    this[t].parentNode !== null && (e ? m(this[t].parentNode).is(e) && i.push(this[t].parentNode) : i.push(this[t].parentNode));
  return m(i);
}
function gt(e) {
  const i = [];
  for (let t = 0; t < this.length; t += 1) {
    let s = this[t].parentNode;
    for (; s; )
      e ? m(s).is(e) && i.push(s) : i.push(s), s = s.parentNode;
  }
  return m(i);
}
function vt(e) {
  let i = this;
  return typeof e > "u" ? m([]) : (i.is(e) || (i = i.parents(e).eq(0)), i);
}
function wt(e) {
  const i = [];
  for (let t = 0; t < this.length; t += 1) {
    const s = this[t].querySelectorAll(e);
    for (let n = 0; n < s.length; n += 1)
      i.push(s[n]);
  }
  return m(i);
}
function St(e) {
  const i = [];
  for (let t = 0; t < this.length; t += 1) {
    const s = this[t].children;
    for (let n = 0; n < s.length; n += 1)
      (!e || m(s[n]).is(e)) && i.push(s[n]);
  }
  return m(i);
}
function Tt() {
  for (let e = 0; e < this.length; e += 1)
    this[e].parentNode && this[e].parentNode.removeChild(this[e]);
  return this;
}
const fe = {
  addClass: Be,
  removeClass: Ve,
  hasClass: He,
  toggleClass: je,
  attr: Re,
  removeAttr: Fe,
  transform: We,
  transition: qe,
  on: Xe,
  off: Ye,
  trigger: Ke,
  transitionEnd: Ue,
  outerWidth: Ze,
  outerHeight: Je,
  styles: et,
  offset: Qe,
  css: tt,
  each: it,
  html: nt,
  text: rt,
  is: lt,
  index: at,
  eq: ot,
  append: dt,
  prepend: ct,
  next: ft,
  nextAll: ut,
  prev: pt,
  prevAll: ht,
  parent: mt,
  parents: gt,
  closest: vt,
  find: wt,
  children: St,
  filter: st,
  remove: Tt
};
Object.keys(fe).forEach((e) => {
  Object.defineProperty(m.fn, e, {
    value: fe[e],
    writable: !0
  });
});
function bt(e) {
  const i = e;
  Object.keys(i).forEach((t) => {
    try {
      i[t] = null;
    } catch {
    }
    try {
      delete i[t];
    } catch {
    }
  });
}
function le(e, i = 0) {
  return setTimeout(e, i);
}
function q() {
  return Date.now();
}
function Et(e) {
  const i = O();
  let t;
  return i.getComputedStyle && (t = i.getComputedStyle(e, null)), !t && e.currentStyle && (t = e.currentStyle), t || (t = e.style), t;
}
function xt(e, i = "x") {
  const t = O();
  let s, n, r;
  const a = Et(e);
  return t.WebKitCSSMatrix ? (n = a.transform || a.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((d) => d.replace(",", ".")).join(", ")), r = new t.WebKitCSSMatrix(n === "none" ? "" : n)) : (r = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = r.toString().split(",")), i === "x" && (t.WebKitCSSMatrix ? n = r.m41 : s.length === 16 ? n = parseFloat(s[12]) : n = parseFloat(s[4])), i === "y" && (t.WebKitCSSMatrix ? n = r.m42 : s.length === 16 ? n = parseFloat(s[13]) : n = parseFloat(s[5])), n || 0;
}
function K(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function Ct(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function _(...e) {
  const i = Object(e[0]), t = ["__proto__", "constructor", "prototype"];
  for (let s = 1; s < e.length; s += 1) {
    const n = e[s];
    if (n != null && !Ct(n)) {
      const r = Object.keys(Object(n)).filter((a) => t.indexOf(a) < 0);
      for (let a = 0, d = r.length; a < d; a += 1) {
        const l = r[a], o = Object.getOwnPropertyDescriptor(n, l);
        o !== void 0 && o.enumerable && (K(i[l]) && K(n[l]) ? n[l].__swiper__ ? i[l] = n[l] : _(i[l], n[l]) : !K(i[l]) && K(n[l]) ? (i[l] = {}, n[l].__swiper__ ? i[l] = n[l] : _(i[l], n[l])) : i[l] = n[l]);
      }
    }
  }
  return i;
}
function U(e, i, t) {
  e.style.setProperty(i, t);
}
function Te({
  swiper: e,
  targetPosition: i,
  side: t
}) {
  const s = O(), n = -e.translate;
  let r = null, a;
  const d = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", s.cancelAnimationFrame(e.cssModeFrameID);
  const l = i > n ? "next" : "prev", o = (u, f) => l === "next" && u >= f || l === "prev" && u <= f, c = () => {
    a = (/* @__PURE__ */ new Date()).getTime(), r === null && (r = a);
    const u = Math.max(Math.min((a - r) / d, 1), 0), f = 0.5 - Math.cos(u * Math.PI) / 2;
    let h = n + f * (i - n);
    if (o(h, i) && (h = i), e.wrapperEl.scrollTo({
      [t]: h
    }), o(h, i)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [t]: h
        });
      }), s.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = s.requestAnimationFrame(c);
  };
  c();
}
let ee;
function yt() {
  const e = O(), i = I();
  return {
    smoothScroll: i.documentElement && "scrollBehavior" in i.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && i instanceof e.DocumentTouch),
    passiveListener: function() {
      let s = !1;
      try {
        const n = Object.defineProperty({}, "passive", {
          // eslint-disable-next-line
          get() {
            s = !0;
          }
        });
        e.addEventListener("testPassiveListener", null, n);
      } catch {
      }
      return s;
    }(),
    gestures: function() {
      return "ongesturestart" in e;
    }()
  };
}
function be() {
  return ee || (ee = yt()), ee;
}
let te;
function Mt({
  userAgent: e
} = {}) {
  const i = be(), t = O(), s = t.navigator.platform, n = e || t.navigator.userAgent, r = {
    ios: !1,
    android: !1
  }, a = t.screen.width, d = t.screen.height, l = n.match(/(Android);?[\s\/]+([\d.]+)?/);
  let o = n.match(/(iPad).*OS\s([\d_]+)/);
  const c = n.match(/(iPod)(.*OS\s([\d_]+))?/), u = !o && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/), f = s === "Win32";
  let h = s === "MacIntel";
  const v = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !o && h && i.touch && v.indexOf(`${a}x${d}`) >= 0 && (o = n.match(/(Version)\/([\d.]+)/), o || (o = [0, 1, "13_0_0"]), h = !1), l && !f && (r.os = "android", r.android = !0), (o || u || c) && (r.os = "ios", r.ios = !0), r;
}
function Lt(e = {}) {
  return te || (te = Mt(e)), te;
}
let ie;
function Ot() {
  const e = O();
  function i() {
    const t = e.navigator.userAgent.toLowerCase();
    return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
  }
  return {
    isSafari: i(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
  };
}
function Pt() {
  return ie || (ie = Ot()), ie;
}
function $t({
  swiper: e,
  on: i,
  emit: t
}) {
  const s = O();
  let n = null, r = null;
  const a = () => {
    !e || e.destroyed || !e.initialized || (t("beforeResize"), t("resize"));
  }, d = () => {
    !e || e.destroyed || !e.initialized || (n = new ResizeObserver((c) => {
      r = s.requestAnimationFrame(() => {
        const {
          width: u,
          height: f
        } = e;
        let h = u, v = f;
        c.forEach(({
          contentBoxSize: w,
          contentRect: g,
          target: p
        }) => {
          p && p !== e.el || (h = g ? g.width : (w[0] || w).inlineSize, v = g ? g.height : (w[0] || w).blockSize);
        }), (h !== u || v !== f) && a();
      });
    }), n.observe(e.el));
  }, l = () => {
    r && s.cancelAnimationFrame(r), n && n.unobserve && e.el && (n.unobserve(e.el), n = null);
  }, o = () => {
    !e || e.destroyed || !e.initialized || t("orientationchange");
  };
  i("init", () => {
    if (e.params.resizeObserver && typeof s.ResizeObserver < "u") {
      d();
      return;
    }
    s.addEventListener("resize", a), s.addEventListener("orientationchange", o);
  }), i("destroy", () => {
    l(), s.removeEventListener("resize", a), s.removeEventListener("orientationchange", o);
  });
}
function _t({
  swiper: e,
  extendParams: i,
  on: t,
  emit: s
}) {
  const n = [], r = O(), a = (o, c = {}) => {
    const u = r.MutationObserver || r.WebkitMutationObserver, f = new u((h) => {
      if (h.length === 1) {
        s("observerUpdate", h[0]);
        return;
      }
      const v = function() {
        s("observerUpdate", h[0]);
      };
      r.requestAnimationFrame ? r.requestAnimationFrame(v) : r.setTimeout(v, 0);
    });
    f.observe(o, {
      attributes: typeof c.attributes > "u" ? !0 : c.attributes,
      childList: typeof c.childList > "u" ? !0 : c.childList,
      characterData: typeof c.characterData > "u" ? !0 : c.characterData
    }), n.push(f);
  }, d = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const o = e.$el.parents();
        for (let c = 0; c < o.length; c += 1)
          a(o[c]);
      }
      a(e.$el[0], {
        childList: e.params.observeSlideChildren
      }), a(e.$wrapperEl[0], {
        attributes: !1
      });
    }
  }, l = () => {
    n.forEach((o) => {
      o.disconnect();
    }), n.splice(0, n.length);
  };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), t("init", d), t("destroy", l);
}
const It = {
  on(e, i, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof i != "function")
      return s;
    const n = t ? "unshift" : "push";
    return e.split(" ").forEach((r) => {
      s.eventsListeners[r] || (s.eventsListeners[r] = []), s.eventsListeners[r][n](i);
    }), s;
  },
  once(e, i, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof i != "function")
      return s;
    function n(...r) {
      s.off(e, n), n.__emitterProxy && delete n.__emitterProxy, i.apply(s, r);
    }
    return n.__emitterProxy = i, s.on(e, n, t);
  },
  onAny(e, i) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof e != "function")
      return t;
    const s = i ? "unshift" : "push";
    return t.eventsAnyListeners.indexOf(e) < 0 && t.eventsAnyListeners[s](e), t;
  },
  offAny(e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || !i.eventsAnyListeners)
      return i;
    const t = i.eventsAnyListeners.indexOf(e);
    return t >= 0 && i.eventsAnyListeners.splice(t, 1), i;
  },
  off(e, i) {
    const t = this;
    return !t.eventsListeners || t.destroyed || !t.eventsListeners || e.split(" ").forEach((s) => {
      typeof i > "u" ? t.eventsListeners[s] = [] : t.eventsListeners[s] && t.eventsListeners[s].forEach((n, r) => {
        (n === i || n.__emitterProxy && n.__emitterProxy === i) && t.eventsListeners[s].splice(r, 1);
      });
    }), t;
  },
  emit(...e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || !i.eventsListeners)
      return i;
    let t, s, n;
    return typeof e[0] == "string" || Array.isArray(e[0]) ? (t = e[0], s = e.slice(1, e.length), n = i) : (t = e[0].events, s = e[0].data, n = e[0].context || i), s.unshift(n), (Array.isArray(t) ? t : t.split(" ")).forEach((a) => {
      i.eventsAnyListeners && i.eventsAnyListeners.length && i.eventsAnyListeners.forEach((d) => {
        d.apply(n, [a, ...s]);
      }), i.eventsListeners && i.eventsListeners[a] && i.eventsListeners[a].forEach((d) => {
        d.apply(n, s);
      });
    }), i;
  }
};
function zt() {
  const e = this;
  let i, t;
  const s = e.$el;
  typeof e.params.width < "u" && e.params.width !== null ? i = e.params.width : i = s[0].clientWidth, typeof e.params.height < "u" && e.params.height !== null ? t = e.params.height : t = s[0].clientHeight, !(i === 0 && e.isHorizontal() || t === 0 && e.isVertical()) && (i = i - parseInt(s.css("padding-left") || 0, 10) - parseInt(s.css("padding-right") || 0, 10), t = t - parseInt(s.css("padding-top") || 0, 10) - parseInt(s.css("padding-bottom") || 0, 10), Number.isNaN(i) && (i = 0), Number.isNaN(t) && (t = 0), Object.assign(e, {
    width: i,
    height: t,
    size: e.isHorizontal() ? i : t
  }));
}
function At() {
  const e = this;
  function i(x) {
    return e.isHorizontal() ? x : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[x];
  }
  function t(x, E) {
    return parseFloat(x.getPropertyValue(i(E)) || 0);
  }
  const s = e.params, {
    $wrapperEl: n,
    size: r,
    rtlTranslate: a,
    wrongRTL: d
  } = e, l = e.virtual && s.virtual.enabled, o = l ? e.virtual.slides.length : e.slides.length, c = n.children(`.${e.params.slideClass}`), u = l ? e.virtual.slides.length : c.length;
  let f = [];
  const h = [], v = [];
  let w = s.slidesOffsetBefore;
  typeof w == "function" && (w = s.slidesOffsetBefore.call(e));
  let g = s.slidesOffsetAfter;
  typeof g == "function" && (g = s.slidesOffsetAfter.call(e));
  const p = e.snapGrid.length, S = e.slidesGrid.length;
  let T = s.spaceBetween, C = -w, b = 0, $ = 0;
  if (typeof r > "u")
    return;
  typeof T == "string" && T.indexOf("%") >= 0 && (T = parseFloat(T.replace("%", "")) / 100 * r), e.virtualSize = -T, a ? c.css({
    marginLeft: "",
    marginBottom: "",
    marginTop: ""
  }) : c.css({
    marginRight: "",
    marginBottom: "",
    marginTop: ""
  }), s.centeredSlides && s.cssMode && (U(e.wrapperEl, "--swiper-centered-offset-before", ""), U(e.wrapperEl, "--swiper-centered-offset-after", ""));
  const G = s.grid && s.grid.rows > 1 && e.grid;
  G && e.grid.initSlides(u);
  let M;
  const R = s.slidesPerView === "auto" && s.breakpoints && Object.keys(s.breakpoints).filter((x) => typeof s.breakpoints[x].slidesPerView < "u").length > 0;
  for (let x = 0; x < u; x += 1) {
    M = 0;
    const E = c.eq(x);
    if (G && e.grid.updateSlide(x, E, u, i), E.css("display") !== "none") {
      if (s.slidesPerView === "auto") {
        R && (c[x].style[i("width")] = "");
        const y = getComputedStyle(E[0]), z = E[0].style.transform, V = E[0].style.webkitTransform;
        if (z && (E[0].style.transform = "none"), V && (E[0].style.webkitTransform = "none"), s.roundLengths)
          M = e.isHorizontal() ? E.outerWidth(!0) : E.outerHeight(!0);
        else {
          const F = t(y, "width"), J = t(y, "padding-left"), Q = t(y, "padding-right"), Y = t(y, "margin-left"), P = t(y, "margin-right"), j = y.getPropertyValue("box-sizing");
          if (j && j === "border-box")
            M = F + Y + P;
          else {
            const {
              clientWidth: Ie,
              offsetWidth: ze
            } = E[0];
            M = F + J + Q + Y + P + (ze - Ie);
          }
        }
        z && (E[0].style.transform = z), V && (E[0].style.webkitTransform = V), s.roundLengths && (M = Math.floor(M));
      } else
        M = (r - (s.slidesPerView - 1) * T) / s.slidesPerView, s.roundLengths && (M = Math.floor(M)), c[x] && (c[x].style[i("width")] = `${M}px`);
      c[x] && (c[x].swiperSlideSize = M), v.push(M), s.centeredSlides ? (C = C + M / 2 + b / 2 + T, b === 0 && x !== 0 && (C = C - r / 2 - T), x === 0 && (C = C - r / 2 - T), Math.abs(C) < 1 / 1e3 && (C = 0), s.roundLengths && (C = Math.floor(C)), $ % s.slidesPerGroup === 0 && f.push(C), h.push(C)) : (s.roundLengths && (C = Math.floor(C)), ($ - Math.min(e.params.slidesPerGroupSkip, $)) % e.params.slidesPerGroup === 0 && f.push(C), h.push(C), C = C + M + T), e.virtualSize += M + T, b = M, $ += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, r) + g, a && d && (s.effect === "slide" || s.effect === "coverflow") && n.css({
    width: `${e.virtualSize + s.spaceBetween}px`
  }), s.setWrapperSize && n.css({
    [i("width")]: `${e.virtualSize + s.spaceBetween}px`
  }), G && e.grid.updateWrapperSize(M, f, i), !s.centeredSlides) {
    const x = [];
    for (let E = 0; E < f.length; E += 1) {
      let y = f[E];
      s.roundLengths && (y = Math.floor(y)), f[E] <= e.virtualSize - r && x.push(y);
    }
    f = x, Math.floor(e.virtualSize - r) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - r);
  }
  if (f.length === 0 && (f = [0]), s.spaceBetween !== 0) {
    const x = e.isHorizontal() && a ? "marginLeft" : i("marginRight");
    c.filter((E, y) => s.cssMode ? y !== c.length - 1 : !0).css({
      [x]: `${T}px`
    });
  }
  if (s.centeredSlides && s.centeredSlidesBounds) {
    let x = 0;
    v.forEach((y) => {
      x += y + (s.spaceBetween ? s.spaceBetween : 0);
    }), x -= s.spaceBetween;
    const E = x - r;
    f = f.map((y) => y < 0 ? -w : y > E ? E + g : y);
  }
  if (s.centerInsufficientSlides) {
    let x = 0;
    if (v.forEach((E) => {
      x += E + (s.spaceBetween ? s.spaceBetween : 0);
    }), x -= s.spaceBetween, x < r) {
      const E = (r - x) / 2;
      f.forEach((y, z) => {
        f[z] = y - E;
      }), h.forEach((y, z) => {
        h[z] = y + E;
      });
    }
  }
  if (Object.assign(e, {
    slides: c,
    snapGrid: f,
    slidesGrid: h,
    slidesSizesGrid: v
  }), s.centeredSlides && s.cssMode && !s.centeredSlidesBounds) {
    U(e.wrapperEl, "--swiper-centered-offset-before", `${-f[0]}px`), U(e.wrapperEl, "--swiper-centered-offset-after", `${e.size / 2 - v[v.length - 1] / 2}px`);
    const x = -e.snapGrid[0], E = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((y) => y + x), e.slidesGrid = e.slidesGrid.map((y) => y + E);
  }
  if (u !== o && e.emit("slidesLengthChange"), f.length !== p && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== S && e.emit("slidesGridLengthChange"), s.watchSlidesProgress && e.updateSlidesOffset(), !l && !s.cssMode && (s.effect === "slide" || s.effect === "fade")) {
    const x = `${s.containerModifierClass}backface-hidden`, E = e.$el.hasClass(x);
    u <= s.maxBackfaceHiddenSlides ? E || e.$el.addClass(x) : E && e.$el.removeClass(x);
  }
}
function kt(e) {
  const i = this, t = [], s = i.virtual && i.params.virtual.enabled;
  let n = 0, r;
  typeof e == "number" ? i.setTransition(e) : e === !0 && i.setTransition(i.params.speed);
  const a = (d) => s ? i.slides.filter((l) => parseInt(l.getAttribute("data-swiper-slide-index"), 10) === d)[0] : i.slides.eq(d)[0];
  if (i.params.slidesPerView !== "auto" && i.params.slidesPerView > 1)
    if (i.params.centeredSlides)
      (i.visibleSlides || m([])).each((d) => {
        t.push(d);
      });
    else
      for (r = 0; r < Math.ceil(i.params.slidesPerView); r += 1) {
        const d = i.activeIndex + r;
        if (d > i.slides.length && !s)
          break;
        t.push(a(d));
      }
  else
    t.push(a(i.activeIndex));
  for (r = 0; r < t.length; r += 1)
    if (typeof t[r] < "u") {
      const d = t[r].offsetHeight;
      n = d > n ? d : n;
    }
  (n || n === 0) && i.$wrapperEl.css("height", `${n}px`);
}
function Dt() {
  const e = this, i = e.slides;
  for (let t = 0; t < i.length; t += 1)
    i[t].swiperSlideOffset = e.isHorizontal() ? i[t].offsetLeft : i[t].offsetTop;
}
function Nt(e = this && this.translate || 0) {
  const i = this, t = i.params, {
    slides: s,
    rtlTranslate: n,
    snapGrid: r
  } = i;
  if (s.length === 0)
    return;
  typeof s[0].swiperSlideOffset > "u" && i.updateSlidesOffset();
  let a = -e;
  n && (a = e), s.removeClass(t.slideVisibleClass), i.visibleSlidesIndexes = [], i.visibleSlides = [];
  for (let d = 0; d < s.length; d += 1) {
    const l = s[d];
    let o = l.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (o -= s[0].swiperSlideOffset);
    const c = (a + (t.centeredSlides ? i.minTranslate() : 0) - o) / (l.swiperSlideSize + t.spaceBetween), u = (a - r[0] + (t.centeredSlides ? i.minTranslate() : 0) - o) / (l.swiperSlideSize + t.spaceBetween), f = -(a - o), h = f + i.slidesSizesGrid[d];
    (f >= 0 && f < i.size - 1 || h > 1 && h <= i.size || f <= 0 && h >= i.size) && (i.visibleSlides.push(l), i.visibleSlidesIndexes.push(d), s.eq(d).addClass(t.slideVisibleClass)), l.progress = n ? -c : c, l.originalProgress = n ? -u : u;
  }
  i.visibleSlides = m(i.visibleSlides);
}
function Gt(e) {
  const i = this;
  if (typeof e > "u") {
    const o = i.rtlTranslate ? -1 : 1;
    e = i && i.translate && i.translate * o || 0;
  }
  const t = i.params, s = i.maxTranslate() - i.minTranslate();
  let {
    progress: n,
    isBeginning: r,
    isEnd: a
  } = i;
  const d = r, l = a;
  s === 0 ? (n = 0, r = !0, a = !0) : (n = (e - i.minTranslate()) / s, r = n <= 0, a = n >= 1), Object.assign(i, {
    progress: n,
    isBeginning: r,
    isEnd: a
  }), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && i.updateSlidesProgress(e), r && !d && i.emit("reachBeginning toEdge"), a && !l && i.emit("reachEnd toEdge"), (d && !r || l && !a) && i.emit("fromEdge"), i.emit("progress", n);
}
function Bt() {
  const e = this, {
    slides: i,
    params: t,
    $wrapperEl: s,
    activeIndex: n,
    realIndex: r
  } = e, a = e.virtual && t.virtual.enabled;
  i.removeClass(`${t.slideActiveClass} ${t.slideNextClass} ${t.slidePrevClass} ${t.slideDuplicateActiveClass} ${t.slideDuplicateNextClass} ${t.slideDuplicatePrevClass}`);
  let d;
  a ? d = e.$wrapperEl.find(`.${t.slideClass}[data-swiper-slide-index="${n}"]`) : d = i.eq(n), d.addClass(t.slideActiveClass), t.loop && (d.hasClass(t.slideDuplicateClass) ? s.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${r}"]`).addClass(t.slideDuplicateActiveClass) : s.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${r}"]`).addClass(t.slideDuplicateActiveClass));
  let l = d.nextAll(`.${t.slideClass}`).eq(0).addClass(t.slideNextClass);
  t.loop && l.length === 0 && (l = i.eq(0), l.addClass(t.slideNextClass));
  let o = d.prevAll(`.${t.slideClass}`).eq(0).addClass(t.slidePrevClass);
  t.loop && o.length === 0 && (o = i.eq(-1), o.addClass(t.slidePrevClass)), t.loop && (l.hasClass(t.slideDuplicateClass) ? s.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicateNextClass) : s.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${l.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicateNextClass), o.hasClass(t.slideDuplicateClass) ? s.children(`.${t.slideClass}:not(.${t.slideDuplicateClass})[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicatePrevClass) : s.children(`.${t.slideClass}.${t.slideDuplicateClass}[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`).addClass(t.slideDuplicatePrevClass)), e.emitSlidesClasses();
}
function Vt(e) {
  const i = this, t = i.rtlTranslate ? i.translate : -i.translate, {
    slidesGrid: s,
    snapGrid: n,
    params: r,
    activeIndex: a,
    realIndex: d,
    snapIndex: l
  } = i;
  let o = e, c;
  if (typeof o > "u") {
    for (let f = 0; f < s.length; f += 1)
      typeof s[f + 1] < "u" ? t >= s[f] && t < s[f + 1] - (s[f + 1] - s[f]) / 2 ? o = f : t >= s[f] && t < s[f + 1] && (o = f + 1) : t >= s[f] && (o = f);
    r.normalizeSlideIndex && (o < 0 || typeof o > "u") && (o = 0);
  }
  if (n.indexOf(t) >= 0)
    c = n.indexOf(t);
  else {
    const f = Math.min(r.slidesPerGroupSkip, o);
    c = f + Math.floor((o - f) / r.slidesPerGroup);
  }
  if (c >= n.length && (c = n.length - 1), o === a) {
    c !== l && (i.snapIndex = c, i.emit("snapIndexChange"));
    return;
  }
  const u = parseInt(i.slides.eq(o).attr("data-swiper-slide-index") || o, 10);
  Object.assign(i, {
    snapIndex: c,
    realIndex: u,
    previousIndex: a,
    activeIndex: o
  }), i.emit("activeIndexChange"), i.emit("snapIndexChange"), d !== u && i.emit("realIndexChange"), (i.initialized || i.params.runCallbacksOnInit) && i.emit("slideChange");
}
function jt(e) {
  const i = this, t = i.params, s = m(e).closest(`.${t.slideClass}`)[0];
  let n = !1, r;
  if (s) {
    for (let a = 0; a < i.slides.length; a += 1)
      if (i.slides[a] === s) {
        n = !0, r = a;
        break;
      }
  }
  if (s && n)
    i.clickedSlide = s, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(m(s).attr("data-swiper-slide-index"), 10) : i.clickedIndex = r;
  else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  t.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
const Ht = {
  updateSize: zt,
  updateSlides: At,
  updateAutoHeight: kt,
  updateSlidesOffset: Dt,
  updateSlidesProgress: Nt,
  updateProgress: Gt,
  updateSlidesClasses: Bt,
  updateActiveIndex: Vt,
  updateClickedSlide: jt
};
function Rt(e = this.isHorizontal() ? "x" : "y") {
  const i = this, {
    params: t,
    rtlTranslate: s,
    translate: n,
    $wrapperEl: r
  } = i;
  if (t.virtualTranslate)
    return s ? -n : n;
  if (t.cssMode)
    return n;
  let a = xt(r[0], e);
  return s && (a = -a), a || 0;
}
function Ft(e, i) {
  const t = this, {
    rtlTranslate: s,
    params: n,
    $wrapperEl: r,
    wrapperEl: a,
    progress: d
  } = t;
  let l = 0, o = 0;
  const c = 0;
  t.isHorizontal() ? l = s ? -e : e : o = e, n.roundLengths && (l = Math.floor(l), o = Math.floor(o)), n.cssMode ? a[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -l : -o : n.virtualTranslate || r.transform(`translate3d(${l}px, ${o}px, ${c}px)`), t.previousTranslate = t.translate, t.translate = t.isHorizontal() ? l : o;
  let u;
  const f = t.maxTranslate() - t.minTranslate();
  f === 0 ? u = 0 : u = (e - t.minTranslate()) / f, u !== d && t.updateProgress(e), t.emit("setTranslate", t.translate, i);
}
function Wt() {
  return -this.snapGrid[0];
}
function qt() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Xt(e = 0, i = this.params.speed, t = !0, s = !0, n) {
  const r = this, {
    params: a,
    wrapperEl: d
  } = r;
  if (r.animating && a.preventInteractionOnTransition)
    return !1;
  const l = r.minTranslate(), o = r.maxTranslate();
  let c;
  if (s && e > l ? c = l : s && e < o ? c = o : c = e, r.updateProgress(c), a.cssMode) {
    const u = r.isHorizontal();
    if (i === 0)
      d[u ? "scrollLeft" : "scrollTop"] = -c;
    else {
      if (!r.support.smoothScroll)
        return Te({
          swiper: r,
          targetPosition: -c,
          side: u ? "left" : "top"
        }), !0;
      d.scrollTo({
        [u ? "left" : "top"]: -c,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return i === 0 ? (r.setTransition(0), r.setTranslate(c), t && (r.emit("beforeTransitionStart", i, n), r.emit("transitionEnd"))) : (r.setTransition(i), r.setTranslate(c), t && (r.emit("beforeTransitionStart", i, n), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(f) {
    !r || r.destroyed || f.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, t && r.emit("transitionEnd"));
  }), r.$wrapperEl[0].addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd))), !0;
}
const Yt = {
  getTranslate: Rt,
  setTranslate: Ft,
  minTranslate: Wt,
  maxTranslate: qt,
  translateTo: Xt
};
function Kt(e, i) {
  const t = this;
  t.params.cssMode || t.$wrapperEl.transition(e), t.emit("setTransition", e, i);
}
function Ee({
  swiper: e,
  runCallbacks: i,
  direction: t,
  step: s
}) {
  const {
    activeIndex: n,
    previousIndex: r
  } = e;
  let a = t;
  if (a || (n > r ? a = "next" : n < r ? a = "prev" : a = "reset"), e.emit(`transition${s}`), i && n !== r) {
    if (a === "reset") {
      e.emit(`slideResetTransition${s}`);
      return;
    }
    e.emit(`slideChangeTransition${s}`), a === "next" ? e.emit(`slideNextTransition${s}`) : e.emit(`slidePrevTransition${s}`);
  }
}
function Ut(e = !0, i) {
  const t = this, {
    params: s
  } = t;
  s.cssMode || (s.autoHeight && t.updateAutoHeight(), Ee({
    swiper: t,
    runCallbacks: e,
    direction: i,
    step: "Start"
  }));
}
function Zt(e = !0, i) {
  const t = this, {
    params: s
  } = t;
  t.animating = !1, !s.cssMode && (t.setTransition(0), Ee({
    swiper: t,
    runCallbacks: e,
    direction: i,
    step: "End"
  }));
}
const Jt = {
  setTransition: Kt,
  transitionStart: Ut,
  transitionEnd: Zt
};
function Qt(e = 0, i = this.params.speed, t = !0, s, n) {
  if (typeof e != "number" && typeof e != "string")
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);
  if (typeof e == "string") {
    const T = parseInt(e, 10);
    if (!isFinite(T))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = T;
  }
  const r = this;
  let a = e;
  a < 0 && (a = 0);
  const {
    params: d,
    snapGrid: l,
    slidesGrid: o,
    previousIndex: c,
    activeIndex: u,
    rtlTranslate: f,
    wrapperEl: h,
    enabled: v
  } = r;
  if (r.animating && d.preventInteractionOnTransition || !v && !s && !n)
    return !1;
  const w = Math.min(r.params.slidesPerGroupSkip, a);
  let g = w + Math.floor((a - w) / r.params.slidesPerGroup);
  g >= l.length && (g = l.length - 1);
  const p = -l[g];
  if (d.normalizeSlideIndex)
    for (let T = 0; T < o.length; T += 1) {
      const C = -Math.floor(p * 100), b = Math.floor(o[T] * 100), $ = Math.floor(o[T + 1] * 100);
      typeof o[T + 1] < "u" ? C >= b && C < $ - ($ - b) / 2 ? a = T : C >= b && C < $ && (a = T + 1) : C >= b && (a = T);
    }
  if (r.initialized && a !== u && (!r.allowSlideNext && p < r.translate && p < r.minTranslate() || !r.allowSlidePrev && p > r.translate && p > r.maxTranslate() && (u || 0) !== a))
    return !1;
  a !== (c || 0) && t && r.emit("beforeSlideChangeStart"), r.updateProgress(p);
  let S;
  if (a > u ? S = "next" : a < u ? S = "prev" : S = "reset", f && -p === r.translate || !f && p === r.translate)
    return r.updateActiveIndex(a), d.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), d.effect !== "slide" && r.setTranslate(p), S !== "reset" && (r.transitionStart(t, S), r.transitionEnd(t, S)), !1;
  if (d.cssMode) {
    const T = r.isHorizontal(), C = f ? p : -p;
    if (i === 0) {
      const b = r.virtual && r.params.virtual.enabled;
      b && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), h[T ? "scrollLeft" : "scrollTop"] = C, b && requestAnimationFrame(() => {
        r.wrapperEl.style.scrollSnapType = "", r._swiperImmediateVirtual = !1;
      });
    } else {
      if (!r.support.smoothScroll)
        return Te({
          swiper: r,
          targetPosition: C,
          side: T ? "left" : "top"
        }), !0;
      h.scrollTo({
        [T ? "left" : "top"]: C,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return r.setTransition(i), r.setTranslate(p), r.updateActiveIndex(a), r.updateSlidesClasses(), r.emit("beforeTransitionStart", i, s), r.transitionStart(t, S), i === 0 ? r.transitionEnd(t, S) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(C) {
    !r || r.destroyed || C.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(t, S));
  }), r.$wrapperEl[0].addEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onSlideToWrapperTransitionEnd)), !0;
}
function ei(e = 0, i = this.params.speed, t = !0, s) {
  if (typeof e == "string") {
    const a = parseInt(e, 10);
    if (!isFinite(a))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);
    e = a;
  }
  const n = this;
  let r = e;
  return n.params.loop && (r += n.loopedSlides), n.slideTo(r, i, t, s);
}
function ti(e = this.params.speed, i = !0, t) {
  const s = this, {
    animating: n,
    enabled: r,
    params: a
  } = s;
  if (!r)
    return s;
  let d = a.slidesPerGroup;
  a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (d = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const l = s.activeIndex < a.slidesPerGroupSkip ? 1 : d;
  if (a.loop) {
    if (n && a.loopPreventsSlide)
      return !1;
    s.loopFix(), s._clientLeft = s.$wrapperEl[0].clientLeft;
  }
  return a.rewind && s.isEnd ? s.slideTo(0, e, i, t) : s.slideTo(s.activeIndex + l, e, i, t);
}
function ii(e = this.params.speed, i = !0, t) {
  const s = this, {
    params: n,
    animating: r,
    snapGrid: a,
    slidesGrid: d,
    rtlTranslate: l,
    enabled: o
  } = s;
  if (!o)
    return s;
  if (n.loop) {
    if (r && n.loopPreventsSlide)
      return !1;
    s.loopFix(), s._clientLeft = s.$wrapperEl[0].clientLeft;
  }
  const c = l ? s.translate : -s.translate;
  function u(g) {
    return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g);
  }
  const f = u(c), h = a.map((g) => u(g));
  let v = a[h.indexOf(f) - 1];
  if (typeof v > "u" && n.cssMode) {
    let g;
    a.forEach((p, S) => {
      f >= p && (g = S);
    }), typeof g < "u" && (v = a[g > 0 ? g - 1 : g]);
  }
  let w = 0;
  if (typeof v < "u" && (w = d.indexOf(v), w < 0 && (w = s.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (w = w - s.slidesPerViewDynamic("previous", !0) + 1, w = Math.max(w, 0))), n.rewind && s.isBeginning) {
    const g = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(g, e, i, t);
  }
  return s.slideTo(w, e, i, t);
}
function si(e = this.params.speed, i = !0, t) {
  const s = this;
  return s.slideTo(s.activeIndex, e, i, t);
}
function ni(e = this.params.speed, i = !0, t, s = 0.5) {
  const n = this;
  let r = n.activeIndex;
  const a = Math.min(n.params.slidesPerGroupSkip, r), d = a + Math.floor((r - a) / n.params.slidesPerGroup), l = n.rtlTranslate ? n.translate : -n.translate;
  if (l >= n.snapGrid[d]) {
    const o = n.snapGrid[d], c = n.snapGrid[d + 1];
    l - o > (c - o) * s && (r += n.params.slidesPerGroup);
  } else {
    const o = n.snapGrid[d - 1], c = n.snapGrid[d];
    l - o <= (c - o) * s && (r -= n.params.slidesPerGroup);
  }
  return r = Math.max(r, 0), r = Math.min(r, n.slidesGrid.length - 1), n.slideTo(r, e, i, t);
}
function ri() {
  const e = this, {
    params: i,
    $wrapperEl: t
  } = e, s = i.slidesPerView === "auto" ? e.slidesPerViewDynamic() : i.slidesPerView;
  let n = e.clickedIndex, r;
  if (i.loop) {
    if (e.animating)
      return;
    r = parseInt(m(e.clickedSlide).attr("data-swiper-slide-index"), 10), i.centeredSlides ? n < e.loopedSlides - s / 2 || n > e.slides.length - e.loopedSlides + s / 2 ? (e.loopFix(), n = t.children(`.${i.slideClass}[data-swiper-slide-index="${r}"]:not(.${i.slideDuplicateClass})`).eq(0).index(), le(() => {
      e.slideTo(n);
    })) : e.slideTo(n) : n > e.slides.length - s ? (e.loopFix(), n = t.children(`.${i.slideClass}[data-swiper-slide-index="${r}"]:not(.${i.slideDuplicateClass})`).eq(0).index(), le(() => {
      e.slideTo(n);
    })) : e.slideTo(n);
  } else
    e.slideTo(n);
}
const li = {
  slideTo: Qt,
  slideToLoop: ei,
  slideNext: ti,
  slidePrev: ii,
  slideReset: si,
  slideToClosest: ni,
  slideToClickedSlide: ri
};
function ai() {
  const e = this, i = I(), {
    params: t,
    $wrapperEl: s
  } = e, n = s.children().length > 0 ? m(s.children()[0].parentNode) : s;
  n.children(`.${t.slideClass}.${t.slideDuplicateClass}`).remove();
  let r = n.children(`.${t.slideClass}`);
  if (t.loopFillGroupWithBlank) {
    const l = t.slidesPerGroup - r.length % t.slidesPerGroup;
    if (l !== t.slidesPerGroup) {
      for (let o = 0; o < l; o += 1) {
        const c = m(i.createElement("div")).addClass(`${t.slideClass} ${t.slideBlankClass}`);
        n.append(c);
      }
      r = n.children(`.${t.slideClass}`);
    }
  }
  t.slidesPerView === "auto" && !t.loopedSlides && (t.loopedSlides = r.length), e.loopedSlides = Math.ceil(parseFloat(t.loopedSlides || t.slidesPerView, 10)), e.loopedSlides += t.loopAdditionalSlides, e.loopedSlides > r.length && e.params.loopedSlidesLimit && (e.loopedSlides = r.length);
  const a = [], d = [];
  r.each((l, o) => {
    m(l).attr("data-swiper-slide-index", o);
  });
  for (let l = 0; l < e.loopedSlides; l += 1) {
    const o = l - Math.floor(l / r.length) * r.length;
    d.push(r.eq(o)[0]), a.unshift(r.eq(r.length - o - 1)[0]);
  }
  for (let l = 0; l < d.length; l += 1)
    n.append(m(d[l].cloneNode(!0)).addClass(t.slideDuplicateClass));
  for (let l = a.length - 1; l >= 0; l -= 1)
    n.prepend(m(a[l].cloneNode(!0)).addClass(t.slideDuplicateClass));
}
function oi() {
  const e = this;
  e.emit("beforeLoopFix");
  const {
    activeIndex: i,
    slides: t,
    loopedSlides: s,
    allowSlidePrev: n,
    allowSlideNext: r,
    snapGrid: a,
    rtlTranslate: d
  } = e;
  let l;
  e.allowSlidePrev = !0, e.allowSlideNext = !0;
  const c = -a[i] - e.getTranslate();
  i < s ? (l = t.length - s * 3 + i, l += s, e.slideTo(l, 0, !1, !0) && c !== 0 && e.setTranslate((d ? -e.translate : e.translate) - c)) : i >= t.length - s && (l = -t.length + i + s, l += s, e.slideTo(l, 0, !1, !0) && c !== 0 && e.setTranslate((d ? -e.translate : e.translate) - c)), e.allowSlidePrev = n, e.allowSlideNext = r, e.emit("loopFix");
}
function di() {
  const e = this, {
    $wrapperEl: i,
    params: t,
    slides: s
  } = e;
  i.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(), s.removeAttr("data-swiper-slide-index");
}
const ci = {
  loopCreate: ai,
  loopFix: oi,
  loopDestroy: di
};
function fi(e) {
  const i = this;
  if (i.support.touch || !i.params.simulateTouch || i.params.watchOverflow && i.isLocked || i.params.cssMode)
    return;
  const t = i.params.touchEventsTarget === "container" ? i.el : i.wrapperEl;
  t.style.cursor = "move", t.style.cursor = e ? "grabbing" : "grab";
}
function ui() {
  const e = this;
  e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "");
}
const pi = {
  setGrabCursor: fi,
  unsetGrabCursor: ui
};
function hi(e, i = this) {
  function t(s) {
    if (!s || s === I() || s === O())
      return null;
    s.assignedSlot && (s = s.assignedSlot);
    const n = s.closest(e);
    return !n && !s.getRootNode ? null : n || t(s.getRootNode().host);
  }
  return t(i);
}
function mi(e) {
  const i = this, t = I(), s = O(), n = i.touchEventsData, {
    params: r,
    touches: a,
    enabled: d
  } = i;
  if (!d || i.animating && r.preventInteractionOnTransition)
    return;
  !i.animating && r.cssMode && r.loop && i.loopFix();
  let l = e;
  l.originalEvent && (l = l.originalEvent);
  let o = m(l.target);
  if (r.touchEventsTarget === "wrapper" && !o.closest(i.wrapperEl).length || (n.isTouchEvent = l.type === "touchstart", !n.isTouchEvent && "which" in l && l.which === 3) || !n.isTouchEvent && "button" in l && l.button > 0 || n.isTouched && n.isMoved)
    return;
  const c = !!r.noSwipingClass && r.noSwipingClass !== "", u = e.composedPath ? e.composedPath() : e.path;
  c && l.target && l.target.shadowRoot && u && (o = m(u[0]));
  const f = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`, h = !!(l.target && l.target.shadowRoot);
  if (r.noSwiping && (h ? hi(f, o[0]) : o.closest(f)[0])) {
    i.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !o.closest(r.swipeHandler)[0])
    return;
  a.currentX = l.type === "touchstart" ? l.targetTouches[0].pageX : l.pageX, a.currentY = l.type === "touchstart" ? l.targetTouches[0].pageY : l.pageY;
  const v = a.currentX, w = a.currentY, g = r.edgeSwipeDetection || r.iOSEdgeSwipeDetection, p = r.edgeSwipeThreshold || r.iOSEdgeSwipeThreshold;
  if (g && (v <= p || v >= s.innerWidth - p))
    if (g === "prevent")
      e.preventDefault();
    else
      return;
  if (Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = v, a.startY = w, n.touchStartTime = q(), i.allowClick = !0, i.updateSize(), i.swipeDirection = void 0, r.threshold > 0 && (n.allowThresholdMove = !1), l.type !== "touchstart") {
    let S = !0;
    o.is(n.focusableElements) && (S = !1, o[0].nodeName === "SELECT" && (n.isTouched = !1)), t.activeElement && m(t.activeElement).is(n.focusableElements) && t.activeElement !== o[0] && t.activeElement.blur();
    const T = S && i.allowTouchMove && r.touchStartPreventDefault;
    (r.touchStartForcePreventDefault || T) && !o[0].isContentEditable && l.preventDefault();
  }
  i.params.freeMode && i.params.freeMode.enabled && i.freeMode && i.animating && !r.cssMode && i.freeMode.onTouchStart(), i.emit("touchStart", l);
}
function gi(e) {
  const i = I(), t = this, s = t.touchEventsData, {
    params: n,
    touches: r,
    rtlTranslate: a,
    enabled: d
  } = t;
  if (!d)
    return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), !s.isTouched) {
    s.startMoving && s.isScrolling && t.emit("touchMoveOpposite", l);
    return;
  }
  if (s.isTouchEvent && l.type !== "touchmove")
    return;
  const o = l.type === "touchmove" && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]), c = l.type === "touchmove" ? o.pageX : l.pageX, u = l.type === "touchmove" ? o.pageY : l.pageY;
  if (l.preventedByNestedSwiper) {
    r.startX = c, r.startY = u;
    return;
  }
  if (!t.allowTouchMove) {
    m(l.target).is(s.focusableElements) || (t.allowClick = !1), s.isTouched && (Object.assign(r, {
      startX: c,
      startY: u,
      currentX: c,
      currentY: u
    }), s.touchStartTime = q());
    return;
  }
  if (s.isTouchEvent && n.touchReleaseOnEdges && !n.loop) {
    if (t.isVertical()) {
      if (u < r.startY && t.translate <= t.maxTranslate() || u > r.startY && t.translate >= t.minTranslate()) {
        s.isTouched = !1, s.isMoved = !1;
        return;
      }
    } else if (c < r.startX && t.translate <= t.maxTranslate() || c > r.startX && t.translate >= t.minTranslate())
      return;
  }
  if (s.isTouchEvent && i.activeElement && l.target === i.activeElement && m(l.target).is(s.focusableElements)) {
    s.isMoved = !0, t.allowClick = !1;
    return;
  }
  if (s.allowTouchCallbacks && t.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1)
    return;
  r.currentX = c, r.currentY = u;
  const f = r.currentX - r.startX, h = r.currentY - r.startY;
  if (t.params.threshold && Math.sqrt(f ** 2 + h ** 2) < t.params.threshold)
    return;
  if (typeof s.isScrolling > "u") {
    let p;
    t.isHorizontal() && r.currentY === r.startY || t.isVertical() && r.currentX === r.startX ? s.isScrolling = !1 : f * f + h * h >= 25 && (p = Math.atan2(Math.abs(h), Math.abs(f)) * 180 / Math.PI, s.isScrolling = t.isHorizontal() ? p > n.touchAngle : 90 - p > n.touchAngle);
  }
  if (s.isScrolling && t.emit("touchMoveOpposite", l), typeof s.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (s.startMoving = !0), s.isScrolling) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving)
    return;
  t.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation(), s.isMoved || (n.loop && !n.cssMode && t.loopFix(), s.startTranslate = t.getTranslate(), t.setTransition(0), t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"), s.allowMomentumBounce = !1, n.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0), t.emit("sliderFirstMove", l)), t.emit("sliderMove", l), s.isMoved = !0;
  let v = t.isHorizontal() ? f : h;
  r.diff = v, v *= n.touchRatio, a && (v = -v), t.swipeDirection = v > 0 ? "prev" : "next", s.currentTranslate = v + s.startTranslate;
  let w = !0, g = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (g = 0), v > 0 && s.currentTranslate > t.minTranslate() ? (w = !1, n.resistance && (s.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + s.startTranslate + v) ** g)) : v < 0 && s.currentTranslate < t.maxTranslate() && (w = !1, n.resistance && (s.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - s.startTranslate - v) ** g)), w && (l.preventedByNestedSwiper = !0), !t.allowSlideNext && t.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !t.allowSlidePrev && t.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !t.allowSlidePrev && !t.allowSlideNext && (s.currentTranslate = s.startTranslate), n.threshold > 0)
    if (Math.abs(v) > n.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        s.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, s.currentTranslate = s.startTranslate, r.diff = t.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && t.freeMode || n.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()), t.params.freeMode && n.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(), t.updateProgress(s.currentTranslate), t.setTranslate(s.currentTranslate));
}
function vi(e) {
  const i = this, t = i.touchEventsData, {
    params: s,
    touches: n,
    rtlTranslate: r,
    slidesGrid: a,
    enabled: d
  } = i;
  if (!d)
    return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), t.allowTouchCallbacks && i.emit("touchEnd", l), t.allowTouchCallbacks = !1, !t.isTouched) {
    t.isMoved && s.grabCursor && i.setGrabCursor(!1), t.isMoved = !1, t.startMoving = !1;
    return;
  }
  s.grabCursor && t.isMoved && t.isTouched && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!1);
  const o = q(), c = o - t.touchStartTime;
  if (i.allowClick) {
    const S = l.path || l.composedPath && l.composedPath();
    i.updateClickedSlide(S && S[0] || l.target), i.emit("tap click", l), c < 300 && o - t.lastClickTime < 300 && i.emit("doubleTap doubleClick", l);
  }
  if (t.lastClickTime = q(), le(() => {
    i.destroyed || (i.allowClick = !0);
  }), !t.isTouched || !t.isMoved || !i.swipeDirection || n.diff === 0 || t.currentTranslate === t.startTranslate) {
    t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
    return;
  }
  t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
  let u;
  if (s.followFinger ? u = r ? i.translate : -i.translate : u = -t.currentTranslate, s.cssMode)
    return;
  if (i.params.freeMode && s.freeMode.enabled) {
    i.freeMode.onTouchEnd({
      currentPos: u
    });
    return;
  }
  let f = 0, h = i.slidesSizesGrid[0];
  for (let S = 0; S < a.length; S += S < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
    const T = S < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
    typeof a[S + T] < "u" ? u >= a[S] && u < a[S + T] && (f = S, h = a[S + T] - a[S]) : u >= a[S] && (f = S, h = a[a.length - 1] - a[a.length - 2]);
  }
  let v = null, w = null;
  s.rewind && (i.isBeginning ? w = i.params.virtual && i.params.virtual.enabled && i.virtual ? i.virtual.slides.length - 1 : i.slides.length - 1 : i.isEnd && (v = 0));
  const g = (u - a[f]) / h, p = f < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
  if (c > s.longSwipesMs) {
    if (!s.longSwipes) {
      i.slideTo(i.activeIndex);
      return;
    }
    i.swipeDirection === "next" && (g >= s.longSwipesRatio ? i.slideTo(s.rewind && i.isEnd ? v : f + p) : i.slideTo(f)), i.swipeDirection === "prev" && (g > 1 - s.longSwipesRatio ? i.slideTo(f + p) : w !== null && g < 0 && Math.abs(g) > s.longSwipesRatio ? i.slideTo(w) : i.slideTo(f));
  } else {
    if (!s.shortSwipes) {
      i.slideTo(i.activeIndex);
      return;
    }
    i.navigation && (l.target === i.navigation.nextEl || l.target === i.navigation.prevEl) ? l.target === i.navigation.nextEl ? i.slideTo(f + p) : i.slideTo(f) : (i.swipeDirection === "next" && i.slideTo(v !== null ? v : f + p), i.swipeDirection === "prev" && i.slideTo(w !== null ? w : f));
  }
}
function ue() {
  const e = this, {
    params: i,
    el: t
  } = e;
  if (t && t.offsetWidth === 0)
    return;
  i.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: s,
    allowSlidePrev: n,
    snapGrid: r
  } = e;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), (i.slidesPerView === "auto" || i.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = n, e.allowSlideNext = s, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
}
function wi(e) {
  const i = this;
  i.enabled && (i.allowClick || (i.params.preventClicks && e.preventDefault(), i.params.preventClicksPropagation && i.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function Si() {
  const e = this, {
    wrapperEl: i,
    rtlTranslate: t,
    enabled: s
  } = e;
  if (!s)
    return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -i.scrollLeft : e.translate = -i.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let n;
  const r = e.maxTranslate() - e.minTranslate();
  r === 0 ? n = 0 : n = (e.translate - e.minTranslate()) / r, n !== e.progress && e.updateProgress(t ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
let pe = !1;
function Ti() {
}
const xe = (e, i) => {
  const t = I(), {
    params: s,
    touchEvents: n,
    el: r,
    wrapperEl: a,
    device: d,
    support: l
  } = e, o = !!s.nested, c = i === "on" ? "addEventListener" : "removeEventListener", u = i;
  if (!l.touch)
    r[c](n.start, e.onTouchStart, !1), t[c](n.move, e.onTouchMove, o), t[c](n.end, e.onTouchEnd, !1);
  else {
    const f = n.start === "touchstart" && l.passiveListener && s.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    r[c](n.start, e.onTouchStart, f), r[c](n.move, e.onTouchMove, l.passiveListener ? {
      passive: !1,
      capture: o
    } : o), r[c](n.end, e.onTouchEnd, f), n.cancel && r[c](n.cancel, e.onTouchEnd, f);
  }
  (s.preventClicks || s.preventClicksPropagation) && r[c]("click", e.onClick, !0), s.cssMode && a[c]("scroll", e.onScroll), s.updateOnWindowResize ? e[u](d.ios || d.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", ue, !0) : e[u]("observerUpdate", ue, !0);
};
function bi() {
  const e = this, i = I(), {
    params: t,
    support: s
  } = e;
  e.onTouchStart = mi.bind(e), e.onTouchMove = gi.bind(e), e.onTouchEnd = vi.bind(e), t.cssMode && (e.onScroll = Si.bind(e)), e.onClick = wi.bind(e), s.touch && !pe && (i.addEventListener("touchstart", Ti), pe = !0), xe(e, "on");
}
function Ei() {
  xe(this, "off");
}
const xi = {
  attachEvents: bi,
  detachEvents: Ei
}, he = (e, i) => e.grid && i.grid && i.grid.rows > 1;
function Ci() {
  const e = this, {
    activeIndex: i,
    initialized: t,
    loopedSlides: s = 0,
    params: n,
    $el: r
  } = e, a = n.breakpoints;
  if (!a || a && Object.keys(a).length === 0)
    return;
  const d = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
  if (!d || e.currentBreakpoint === d)
    return;
  const o = (d in a ? a[d] : void 0) || e.originalParams, c = he(e, n), u = he(e, o), f = n.enabled;
  c && !u ? (r.removeClass(`${n.containerModifierClass}grid ${n.containerModifierClass}grid-column`), e.emitContainerClasses()) : !c && u && (r.addClass(`${n.containerModifierClass}grid`), (o.grid.fill && o.grid.fill === "column" || !o.grid.fill && n.grid.fill === "column") && r.addClass(`${n.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((g) => {
    const p = n[g] && n[g].enabled, S = o[g] && o[g].enabled;
    p && !S && e[g].disable(), !p && S && e[g].enable();
  });
  const h = o.direction && o.direction !== n.direction, v = n.loop && (o.slidesPerView !== n.slidesPerView || h);
  h && t && e.changeDirection(), _(e.params, o);
  const w = e.params.enabled;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), f && !w ? e.disable() : !f && w && e.enable(), e.currentBreakpoint = d, e.emit("_beforeBreakpoint", o), v && t && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(i - s + e.loopedSlides, 0, !1)), e.emit("breakpoint", o);
}
function yi(e, i = "window", t) {
  if (!e || i === "container" && !t)
    return;
  let s = !1;
  const n = O(), r = i === "window" ? n.innerHeight : t.clientHeight, a = Object.keys(e).map((d) => {
    if (typeof d == "string" && d.indexOf("@") === 0) {
      const l = parseFloat(d.substr(1));
      return {
        value: r * l,
        point: d
      };
    }
    return {
      value: d,
      point: d
    };
  });
  a.sort((d, l) => parseInt(d.value, 10) - parseInt(l.value, 10));
  for (let d = 0; d < a.length; d += 1) {
    const {
      point: l,
      value: o
    } = a[d];
    i === "window" ? n.matchMedia(`(min-width: ${o}px)`).matches && (s = l) : o <= t.clientWidth && (s = l);
  }
  return s || "max";
}
const Mi = {
  setBreakpoint: Ci,
  getBreakpoint: yi
};
function Li(e, i) {
  const t = [];
  return e.forEach((s) => {
    typeof s == "object" ? Object.keys(s).forEach((n) => {
      s[n] && t.push(i + n);
    }) : typeof s == "string" && t.push(i + s);
  }), t;
}
function Oi() {
  const e = this, {
    classNames: i,
    params: t,
    rtl: s,
    $el: n,
    device: r,
    support: a
  } = e, d = Li(["initialized", t.direction, {
    "pointer-events": !a.touch
  }, {
    "free-mode": e.params.freeMode && t.freeMode.enabled
  }, {
    autoheight: t.autoHeight
  }, {
    rtl: s
  }, {
    grid: t.grid && t.grid.rows > 1
  }, {
    "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column"
  }, {
    android: r.android
  }, {
    ios: r.ios
  }, {
    "css-mode": t.cssMode
  }, {
    centered: t.cssMode && t.centeredSlides
  }, {
    "watch-progress": t.watchSlidesProgress
  }], t.containerModifierClass);
  i.push(...d), n.addClass([...i].join(" ")), e.emitContainerClasses();
}
function Pi() {
  const e = this, {
    $el: i,
    classNames: t
  } = e;
  i.removeClass(t.join(" ")), e.emitContainerClasses();
}
const $i = {
  addClasses: Oi,
  removeClasses: Pi
};
function _i(e, i, t, s, n, r) {
  const a = O();
  let d;
  function l() {
    r && r();
  }
  !m(e).parent("picture")[0] && (!e.complete || !n) && i ? (d = new a.Image(), d.onload = l, d.onerror = l, s && (d.sizes = s), t && (d.srcset = t), i && (d.src = i)) : l();
}
function Ii() {
  const e = this;
  e.imagesToLoad = e.$el.find("img");
  function i() {
    typeof e > "u" || e === null || !e || e.destroyed || (e.imagesLoaded !== void 0 && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
  }
  for (let t = 0; t < e.imagesToLoad.length; t += 1) {
    const s = e.imagesToLoad[t];
    e.loadImage(s, s.currentSrc || s.getAttribute("src"), s.srcset || s.getAttribute("srcset"), s.sizes || s.getAttribute("sizes"), !0, i);
  }
}
const zi = {
  loadImage: _i,
  preloadImages: Ii
};
function Ai() {
  const e = this, {
    isLocked: i,
    params: t
  } = e, {
    slidesOffsetBefore: s
  } = t;
  if (s) {
    const n = e.slides.length - 1, r = e.slidesGrid[n] + e.slidesSizesGrid[n] + s * 2;
    e.isLocked = e.size > r;
  } else
    e.isLocked = e.snapGrid.length === 1;
  t.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), t.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), i && i !== e.isLocked && (e.isEnd = !1), i !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
const ki = {
  checkOverflow: Ai
}, me = {
  init: !0,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 0,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // Images
  preloadImages: !0,
  updateOnImagesReady: !0,
  // loop
  loop: !1,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: !0,
  loopFillGroupWithBlank: !1,
  loopPreventsSlide: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function Di(e, i) {
  return function(s = {}) {
    const n = Object.keys(s)[0], r = s[n];
    if (typeof r != "object" || r === null) {
      _(i, s);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(n) >= 0 && e[n] === !0 && (e[n] = {
      auto: !0
    }), !(n in e && "enabled" in r)) {
      _(i, s);
      return;
    }
    e[n] === !0 && (e[n] = {
      enabled: !0
    }), typeof e[n] == "object" && !("enabled" in e[n]) && (e[n].enabled = !0), e[n] || (e[n] = {
      enabled: !1
    }), _(i, s);
  };
}
const se = {
  eventsEmitter: It,
  update: Ht,
  translate: Yt,
  transition: Jt,
  slide: li,
  loop: ci,
  grabCursor: pi,
  events: xi,
  breakpoints: Mi,
  checkOverflow: ki,
  classes: $i,
  images: zi
}, ne = {};
let H = class k {
  constructor(...i) {
    let t, s;
    if (i.length === 1 && i[0].constructor && Object.prototype.toString.call(i[0]).slice(8, -1) === "Object" ? s = i[0] : [t, s] = i, s || (s = {}), s = _({}, s), t && !s.el && (s.el = t), s.el && m(s.el).length > 1) {
      const d = [];
      return m(s.el).each((l) => {
        const o = _({}, s, {
          el: l
        });
        d.push(new k(o));
      }), d;
    }
    const n = this;
    n.__swiper__ = !0, n.support = be(), n.device = Lt({
      userAgent: s.userAgent
    }), n.browser = Pt(), n.eventsListeners = {}, n.eventsAnyListeners = [], n.modules = [...n.__modules__], s.modules && Array.isArray(s.modules) && n.modules.push(...s.modules);
    const r = {};
    n.modules.forEach((d) => {
      d({
        swiper: n,
        extendParams: Di(s, r),
        on: n.on.bind(n),
        once: n.once.bind(n),
        off: n.off.bind(n),
        emit: n.emit.bind(n)
      });
    });
    const a = _({}, me, r);
    return n.params = _({}, a, ne, s), n.originalParams = _({}, n.params), n.passedParams = _({}, s), n.params && n.params.on && Object.keys(n.params.on).forEach((d) => {
      n.on(d, n.params.on[d]);
    }), n.params && n.params.onAny && n.onAny(n.params.onAny), n.$ = m, Object.assign(n, {
      enabled: n.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: m(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return n.params.direction === "horizontal";
      },
      isVertical() {
        return n.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      // Locks
      allowSlideNext: n.params.allowSlideNext,
      allowSlidePrev: n.params.allowSlidePrev,
      // Touch Events
      touchEvents: function() {
        const l = ["touchstart", "touchmove", "touchend", "touchcancel"], o = ["pointerdown", "pointermove", "pointerup"];
        return n.touchEventsTouch = {
          start: l[0],
          move: l[1],
          end: l[2],
          cancel: l[3]
        }, n.touchEventsDesktop = {
          start: o[0],
          move: o[1],
          end: o[2]
        }, n.support.touch || !n.params.simulateTouch ? n.touchEventsTouch : n.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: n.params.focusableElements,
        // Last click time
        lastClickTime: q(),
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: n.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), n.emit("_swiper"), n.params.init && n.init(), n;
  }
  enable() {
    const i = this;
    i.enabled || (i.enabled = !0, i.params.grabCursor && i.setGrabCursor(), i.emit("enable"));
  }
  disable() {
    const i = this;
    i.enabled && (i.enabled = !1, i.params.grabCursor && i.unsetGrabCursor(), i.emit("disable"));
  }
  setProgress(i, t) {
    const s = this;
    i = Math.min(Math.max(i, 0), 1);
    const n = s.minTranslate(), a = (s.maxTranslate() - n) * i + n;
    s.translateTo(a, typeof t > "u" ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const i = this;
    if (!i.params._emitClasses || !i.el)
      return;
    const t = i.el.className.split(" ").filter((s) => s.indexOf("swiper") === 0 || s.indexOf(i.params.containerModifierClass) === 0);
    i.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(i) {
    const t = this;
    return t.destroyed ? "" : i.className.split(" ").filter((s) => s.indexOf("swiper-slide") === 0 || s.indexOf(t.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const i = this;
    if (!i.params._emitClasses || !i.el)
      return;
    const t = [];
    i.slides.each((s) => {
      const n = i.getSlideClasses(s);
      t.push({
        slideEl: s,
        classNames: n
      }), i.emit("_slideClass", s, n);
    }), i.emit("_slideClasses", t);
  }
  slidesPerViewDynamic(i = "current", t = !1) {
    const s = this, {
      params: n,
      slides: r,
      slidesGrid: a,
      slidesSizesGrid: d,
      size: l,
      activeIndex: o
    } = s;
    let c = 1;
    if (n.centeredSlides) {
      let u = r[o].swiperSlideSize, f;
      for (let h = o + 1; h < r.length; h += 1)
        r[h] && !f && (u += r[h].swiperSlideSize, c += 1, u > l && (f = !0));
      for (let h = o - 1; h >= 0; h -= 1)
        r[h] && !f && (u += r[h].swiperSlideSize, c += 1, u > l && (f = !0));
    } else if (i === "current")
      for (let u = o + 1; u < r.length; u += 1)
        (t ? a[u] + d[u] - a[o] < l : a[u] - a[o] < l) && (c += 1);
    else
      for (let u = o - 1; u >= 0; u -= 1)
        a[o] - a[u] < l && (c += 1);
    return c;
  }
  update() {
    const i = this;
    if (!i || i.destroyed)
      return;
    const {
      snapGrid: t,
      params: s
    } = i;
    s.breakpoints && i.setBreakpoint(), i.updateSize(), i.updateSlides(), i.updateProgress(), i.updateSlidesClasses();
    function n() {
      const a = i.rtlTranslate ? i.translate * -1 : i.translate, d = Math.min(Math.max(a, i.maxTranslate()), i.minTranslate());
      i.setTranslate(d), i.updateActiveIndex(), i.updateSlidesClasses();
    }
    let r;
    i.params.freeMode && i.params.freeMode.enabled ? (n(), i.params.autoHeight && i.updateAutoHeight()) : ((i.params.slidesPerView === "auto" || i.params.slidesPerView > 1) && i.isEnd && !i.params.centeredSlides ? r = i.slideTo(i.slides.length - 1, 0, !1, !0) : r = i.slideTo(i.activeIndex, 0, !1, !0), r || n()), s.watchOverflow && t !== i.snapGrid && i.checkOverflow(), i.emit("update");
  }
  changeDirection(i, t = !0) {
    const s = this, n = s.params.direction;
    return i || (i = n === "horizontal" ? "vertical" : "horizontal"), i === n || i !== "horizontal" && i !== "vertical" || (s.$el.removeClass(`${s.params.containerModifierClass}${n}`).addClass(`${s.params.containerModifierClass}${i}`), s.emitContainerClasses(), s.params.direction = i, s.slides.each((r) => {
      i === "vertical" ? r.style.width = "" : r.style.height = "";
    }), s.emit("changeDirection"), t && s.update()), s;
  }
  changeLanguageDirection(i) {
    const t = this;
    t.rtl && i === "rtl" || !t.rtl && i === "ltr" || (t.rtl = i === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.$el.addClass(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.$el.removeClass(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
  }
  mount(i) {
    const t = this;
    if (t.mounted)
      return !0;
    const s = m(i || t.params.el);
    if (i = s[0], !i)
      return !1;
    i.swiper = t;
    const n = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let a = (() => {
      if (i && i.shadowRoot && i.shadowRoot.querySelector) {
        const d = m(i.shadowRoot.querySelector(n()));
        return d.children = (l) => s.children(l), d;
      }
      return s.children ? s.children(n()) : m(s).children(n());
    })();
    if (a.length === 0 && t.params.createElements) {
      const l = I().createElement("div");
      a = m(l), l.className = t.params.wrapperClass, s.append(l), s.children(`.${t.params.slideClass}`).each((o) => {
        a.append(o);
      });
    }
    return Object.assign(t, {
      $el: s,
      el: i,
      $wrapperEl: a,
      wrapperEl: a[0],
      mounted: !0,
      // RTL
      rtl: i.dir.toLowerCase() === "rtl" || s.css("direction") === "rtl",
      rtlTranslate: t.params.direction === "horizontal" && (i.dir.toLowerCase() === "rtl" || s.css("direction") === "rtl"),
      wrongRTL: a.css("display") === "-webkit-box"
    }), !0;
  }
  init(i) {
    const t = this;
    return t.initialized || t.mount(i) === !1 || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.attachEvents(), t.initialized = !0, t.emit("init"), t.emit("afterInit")), t;
  }
  destroy(i = !0, t = !0) {
    const s = this, {
      params: n,
      $el: r,
      $wrapperEl: a,
      slides: d
    } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), n.loop && s.loopDestroy(), t && (s.removeClasses(), r.removeAttr("style"), a.removeAttr("style"), d && d.length && d.removeClass([n.slideVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((l) => {
      s.off(l);
    }), i !== !1 && (s.$el[0].swiper = null, bt(s)), s.destroyed = !0), null;
  }
  static extendDefaults(i) {
    _(ne, i);
  }
  static get extendedDefaults() {
    return ne;
  }
  static get defaults() {
    return me;
  }
  static installModule(i) {
    k.prototype.__modules__ || (k.prototype.__modules__ = []);
    const t = k.prototype.__modules__;
    typeof i == "function" && t.indexOf(i) < 0 && t.push(i);
  }
  static use(i) {
    return Array.isArray(i) ? (i.forEach((t) => k.installModule(t)), k) : (k.installModule(i), k);
  }
};
Object.keys(se).forEach((e) => {
  Object.keys(se[e]).forEach((i) => {
    H.prototype[i] = se[e][i];
  });
});
H.use([$t, _t]);
function B(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function N(e, i) {
  const t = ["__proto__", "constructor", "prototype"];
  Object.keys(i).filter((s) => t.indexOf(s) < 0).forEach((s) => {
    typeof e[s] > "u" ? e[s] = i[s] : B(i[s]) && B(e[s]) && Object.keys(i[s]).length > 0 ? i[s].__swiper__ ? e[s] = i[s] : N(e[s], i[s]) : e[s] = i[s];
  });
}
function Ce(e = {}) {
  return e.navigation && typeof e.navigation.nextEl > "u" && typeof e.navigation.prevEl > "u";
}
function ye(e = {}) {
  return e.pagination && typeof e.pagination.el > "u";
}
function Me(e = {}) {
  return e.scrollbar && typeof e.scrollbar.el > "u";
}
function Le(e = "") {
  const i = e.split(" ").map((s) => s.trim()).filter((s) => !!s), t = [];
  return i.forEach((s) => {
    t.indexOf(s) < 0 && t.push(s);
  }), t.join(" ");
}
const Oe = [
  "modules",
  "init",
  "_direction",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_preloadImages",
  "updateOnImagesReady",
  "_loop",
  "_loopAdditionalSlides",
  "_loopedSlides",
  "_loopedSlidesLimit",
  "_loopFillGroupWithBlank",
  "loopPreventsSlide",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideBlankClass",
  "slideActiveClass",
  "slideDuplicateActiveClass",
  "slideVisibleClass",
  "slideDuplicateClass",
  "slideNextClass",
  "slideDuplicateNextClass",
  "slidePrevClass",
  "slideDuplicatePrevClass",
  "wrapperClass",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "lazy",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom"
];
function Ni(e = {}, i = !0) {
  const t = {
    on: {}
  }, s = {}, n = {};
  N(t, H.defaults), N(t, H.extendedDefaults), t._emitClasses = !0, t.init = !1;
  const r = {}, a = Oe.map((l) => l.replace(/_/, "")), d = Object.assign({}, e);
  return Object.keys(d).forEach((l) => {
    typeof e[l] > "u" || (a.indexOf(l) >= 0 ? B(e[l]) ? (t[l] = {}, n[l] = {}, N(t[l], e[l]), N(n[l], e[l])) : (t[l] = e[l], n[l] = e[l]) : l.search(/on[A-Z]/) === 0 && typeof e[l] == "function" ? i ? s[`${l[2].toLowerCase()}${l.substr(3)}`] = e[l] : t.on[`${l[2].toLowerCase()}${l.substr(3)}`] = e[l] : r[l] = e[l]);
  }), ["navigation", "pagination", "scrollbar"].forEach((l) => {
    t[l] === !0 && (t[l] = {}), t[l] === !1 && delete t[l];
  }), {
    params: t,
    passedParams: n,
    rest: r,
    events: s
  };
}
function Gi({
  el: e,
  nextEl: i,
  prevEl: t,
  paginationEl: s,
  scrollbarEl: n,
  swiper: r
}, a) {
  Ce(a) && i && t && (r.params.navigation.nextEl = i, r.originalParams.navigation.nextEl = i, r.params.navigation.prevEl = t, r.originalParams.navigation.prevEl = t), ye(a) && s && (r.params.pagination.el = s, r.originalParams.pagination.el = s), Me(a) && n && (r.params.scrollbar.el = n, r.originalParams.scrollbar.el = n), r.init(e);
}
const Pe = (e, i) => {
  let t = i.slidesPerView;
  if (i.breakpoints) {
    const n = H.prototype.getBreakpoint(i.breakpoints), r = n in i.breakpoints ? i.breakpoints[n] : void 0;
    r && r.slidesPerView && (t = r.slidesPerView);
  }
  let s = Math.ceil(parseFloat(i.loopedSlides || t, 10));
  return s += i.loopAdditionalSlides, s > e.length && i.loopedSlidesLimit && (s = e.length), s;
};
function Bi(e, i, t) {
  const s = i.map((l, o) => /* @__PURE__ */ L.cloneElement(l, {
    swiper: e,
    "data-swiper-slide-index": o
  }));
  function n(l, o, c) {
    return /* @__PURE__ */ L.cloneElement(l, {
      key: `${l.key}-duplicate-${o}-${c}`,
      className: `${l.props.className || ""} ${t.slideDuplicateClass}`
    });
  }
  if (t.loopFillGroupWithBlank) {
    const l = t.slidesPerGroup - s.length % t.slidesPerGroup;
    if (l !== t.slidesPerGroup)
      for (let o = 0; o < l; o += 1) {
        const c = /* @__PURE__ */ L.createElement("div", {
          className: `${t.slideClass} ${t.slideBlankClass}`
        });
        s.push(c);
      }
  }
  t.slidesPerView === "auto" && !t.loopedSlides && (t.loopedSlides = s.length);
  const r = Pe(s, t), a = [], d = [];
  for (let l = 0; l < r; l += 1) {
    const o = l - Math.floor(l / s.length) * s.length;
    d.push(n(s[o], l, "append")), a.unshift(n(s[s.length - o - 1], l, "prepend"));
  }
  return e && (e.loopedSlides = r), [...a, ...s, ...d];
}
function Vi(e, i, t, s, n) {
  const r = [];
  if (!i)
    return r;
  const a = (l) => {
    r.indexOf(l) < 0 && r.push(l);
  };
  if (t && s) {
    const l = s.map(n), o = t.map(n);
    l.join("") !== o.join("") && a("children"), s.length !== t.length && a("children");
  }
  return Oe.filter((l) => l[0] === "_").map((l) => l.replace(/_/, "")).forEach((l) => {
    if (l in e && l in i)
      if (B(e[l]) && B(i[l])) {
        const o = Object.keys(e[l]), c = Object.keys(i[l]);
        o.length !== c.length ? a(l) : (o.forEach((u) => {
          e[l][u] !== i[l][u] && a(l);
        }), c.forEach((u) => {
          e[l][u] !== i[l][u] && a(l);
        }));
      } else
        e[l] !== i[l] && a(l);
  }), r;
}
function $e(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function _e(e) {
  const i = [];
  return L.Children.toArray(e).forEach((t) => {
    $e(t) ? i.push(t) : t.props && t.props.children && _e(t.props.children).forEach((s) => i.push(s));
  }), i;
}
function ji(e) {
  const i = [], t = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return L.Children.toArray(e).forEach((s) => {
    if ($e(s))
      i.push(s);
    else if (s.props && s.props.slot && t[s.props.slot])
      t[s.props.slot].push(s);
    else if (s.props && s.props.children) {
      const n = _e(s.props.children);
      n.length > 0 ? n.forEach((r) => i.push(r)) : t["container-end"].push(s);
    } else
      t["container-end"].push(s);
  }), {
    slides: i,
    slots: t
  };
}
function Hi({
  swiper: e,
  slides: i,
  passedParams: t,
  changedParams: s,
  nextEl: n,
  prevEl: r,
  scrollbarEl: a,
  paginationEl: d
}) {
  const l = s.filter((b) => b !== "children" && b !== "direction"), {
    params: o,
    pagination: c,
    navigation: u,
    scrollbar: f,
    virtual: h,
    thumbs: v
  } = e;
  let w, g, p, S, T;
  s.includes("thumbs") && t.thumbs && t.thumbs.swiper && o.thumbs && !o.thumbs.swiper && (w = !0), s.includes("controller") && t.controller && t.controller.control && o.controller && !o.controller.control && (g = !0), s.includes("pagination") && t.pagination && (t.pagination.el || d) && (o.pagination || o.pagination === !1) && c && !c.el && (p = !0), s.includes("scrollbar") && t.scrollbar && (t.scrollbar.el || a) && (o.scrollbar || o.scrollbar === !1) && f && !f.el && (S = !0), s.includes("navigation") && t.navigation && (t.navigation.prevEl || r) && (t.navigation.nextEl || n) && (o.navigation || o.navigation === !1) && u && !u.prevEl && !u.nextEl && (T = !0);
  const C = (b) => {
    e[b] && (e[b].destroy(), b === "navigation" ? (o[b].prevEl = void 0, o[b].nextEl = void 0, e[b].prevEl = void 0, e[b].nextEl = void 0) : (o[b].el = void 0, e[b].el = void 0));
  };
  l.forEach((b) => {
    if (B(o[b]) && B(t[b]))
      N(o[b], t[b]);
    else {
      const $ = t[b];
      ($ === !0 || $ === !1) && (b === "navigation" || b === "pagination" || b === "scrollbar") ? $ === !1 && C(b) : o[b] = t[b];
    }
  }), l.includes("controller") && !g && e.controller && e.controller.control && o.controller && o.controller.control && (e.controller.control = o.controller.control), s.includes("children") && i && h && o.virtual.enabled ? (h.slides = i, h.update(!0)) : s.includes("children") && e.lazy && e.params.lazy.enabled && e.lazy.load(), w && v.init() && v.update(!0), g && (e.controller.control = o.controller.control), p && (d && (o.pagination.el = d), c.init(), c.render(), c.update()), S && (a && (o.scrollbar.el = a), f.init(), f.updateSize(), f.setTranslate()), T && (n && (o.navigation.nextEl = n), r && (o.navigation.prevEl = r), u.init(), u.update()), s.includes("allowSlideNext") && (e.allowSlideNext = t.allowSlideNext), s.includes("allowSlidePrev") && (e.allowSlidePrev = t.allowSlidePrev), s.includes("direction") && e.changeDirection(t.direction, !1), e.update();
}
function Ri(e, i, t) {
  if (!t)
    return null;
  const s = e.isHorizontal() ? {
    [e.rtlTranslate ? "right" : "left"]: `${t.offset}px`
  } : {
    top: `${t.offset}px`
  };
  return i.filter((n, r) => r >= t.from && r <= t.to).map((n) => /* @__PURE__ */ L.cloneElement(n, {
    swiper: e,
    style: s
  }));
}
const Fi = (e) => {
  !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
};
function W(e, i) {
  return typeof window > "u" ? re(e, i) : Ae(e, i);
}
const Wi = /* @__PURE__ */ ge(null), qi = /* @__PURE__ */ ge(null);
function ae() {
  return ae = Object.assign ? Object.assign.bind() : function(e) {
    for (var i = 1; i < arguments.length; i++) {
      var t = arguments[i];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, ae.apply(this, arguments);
}
const Xi = /* @__PURE__ */ ve(function(e, i) {
  let {
    className: t,
    tag: s = "div",
    wrapperTag: n = "div",
    children: r,
    onSwiper: a,
    ...d
  } = e === void 0 ? {} : e, l = !1;
  const [o, c] = Z("swiper"), [u, f] = Z(null), [h, v] = Z(!1), w = A(!1), g = A(null), p = A(null), S = A(null), T = A(null), C = A(null), b = A(null), $ = A(null), G = A(null), {
    params: M,
    passedParams: R,
    rest: x,
    events: E
  } = Ni(d), {
    slides: y,
    slots: z
  } = ji(r), V = () => {
    v(!h);
  };
  Object.assign(M.on, {
    _containerClasses(P, j) {
      c(j);
    }
  });
  const F = () => {
    if (Object.assign(M.on, E), l = !0, p.current = new H(M), p.current.loopCreate = () => {
    }, p.current.loopDestroy = () => {
    }, M.loop && (p.current.loopedSlides = Pe(y, M)), p.current.virtual && p.current.params.virtual.enabled) {
      p.current.virtual.slides = y;
      const P = {
        cache: !1,
        slides: y,
        renderExternal: f,
        renderExternalUpdate: !1
      };
      N(p.current.params.virtual, P), N(p.current.originalParams.virtual, P);
    }
  };
  g.current || F(), p.current && p.current.on("_beforeBreakpoint", V);
  const J = () => {
    l || !E || !p.current || Object.keys(E).forEach((P) => {
      p.current.on(P, E[P]);
    });
  }, Q = () => {
    !E || !p.current || Object.keys(E).forEach((P) => {
      p.current.off(P, E[P]);
    });
  };
  re(() => () => {
    p.current && p.current.off("_beforeBreakpoint", V);
  }), re(() => {
    !w.current && p.current && (p.current.emitSlidesClasses(), w.current = !0);
  }), W(() => {
    if (i && (i.current = g.current), !!g.current)
      return p.current.destroyed && F(), Gi({
        el: g.current,
        nextEl: C.current,
        prevEl: b.current,
        paginationEl: $.current,
        scrollbarEl: G.current,
        swiper: p.current
      }, M), a && a(p.current), () => {
        p.current && !p.current.destroyed && p.current.destroy(!0, !1);
      };
  }, []), W(() => {
    J();
    const P = Vi(R, S.current, y, T.current, (j) => j.key);
    return S.current = R, T.current = y, P.length && p.current && !p.current.destroyed && Hi({
      swiper: p.current,
      slides: y,
      passedParams: R,
      changedParams: P,
      nextEl: C.current,
      prevEl: b.current,
      scrollbarEl: G.current,
      paginationEl: $.current
    }), () => {
      Q();
    };
  }), W(() => {
    Fi(p.current);
  }, [u]);
  function Y() {
    return M.virtual ? Ri(p.current, y, u) : !M.loop || p.current && p.current.destroyed ? y.map((P) => /* @__PURE__ */ L.cloneElement(P, {
      swiper: p.current
    })) : Bi(p.current, y, M);
  }
  return /* @__PURE__ */ L.createElement(s, ae({
    ref: g,
    className: Le(`${o}${t ? ` ${t}` : ""}`)
  }, x), /* @__PURE__ */ L.createElement(qi.Provider, {
    value: p.current
  }, z["container-start"], /* @__PURE__ */ L.createElement(n, {
    className: "swiper-wrapper"
  }, z["wrapper-start"], Y(), z["wrapper-end"]), Ce(M) && /* @__PURE__ */ L.createElement(L.Fragment, null, /* @__PURE__ */ L.createElement("div", {
    ref: b,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ L.createElement("div", {
    ref: C,
    className: "swiper-button-next"
  })), Me(M) && /* @__PURE__ */ L.createElement("div", {
    ref: G,
    className: "swiper-scrollbar"
  }), ye(M) && /* @__PURE__ */ L.createElement("div", {
    ref: $,
    className: "swiper-pagination"
  }), z["container-end"]));
});
Xi.displayName = "Swiper";
function oe() {
  return oe = Object.assign ? Object.assign.bind() : function(e) {
    for (var i = 1; i < arguments.length; i++) {
      var t = arguments[i];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, oe.apply(this, arguments);
}
const Yi = /* @__PURE__ */ ve(function(e, i) {
  let {
    tag: t = "div",
    children: s,
    className: n = "",
    swiper: r,
    zoom: a,
    virtualIndex: d,
    ...l
  } = e === void 0 ? {} : e;
  const o = A(null), [c, u] = Z("swiper-slide");
  function f(w, g, p) {
    g === o.current && u(p);
  }
  W(() => {
    if (i && (i.current = o.current), !(!o.current || !r)) {
      if (r.destroyed) {
        c !== "swiper-slide" && u("swiper-slide");
        return;
      }
      return r.on("_slideClass", f), () => {
        r && r.off("_slideClass", f);
      };
    }
  }), W(() => {
    r && o.current && !r.destroyed && u(r.getSlideClasses(o.current));
  }, [r]);
  const h = {
    isActive: c.indexOf("swiper-slide-active") >= 0 || c.indexOf("swiper-slide-duplicate-active") >= 0,
    isVisible: c.indexOf("swiper-slide-visible") >= 0,
    isDuplicate: c.indexOf("swiper-slide-duplicate") >= 0,
    isPrev: c.indexOf("swiper-slide-prev") >= 0 || c.indexOf("swiper-slide-duplicate-prev") >= 0,
    isNext: c.indexOf("swiper-slide-next") >= 0 || c.indexOf("swiper-slide-duplicate-next") >= 0
  }, v = () => typeof s == "function" ? s(h) : s;
  return /* @__PURE__ */ L.createElement(t, oe({
    ref: o,
    className: Le(`${c}${n ? ` ${n}` : ""}`),
    "data-swiper-slide-index": d
  }, l), /* @__PURE__ */ L.createElement(Wi.Provider, {
    value: h
  }, a ? /* @__PURE__ */ L.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof a == "number" ? a : void 0
  }, v()) : v()));
});
Yi.displayName = "SwiperSlide";
export {
  Xi as S,
  Yi as a,
  I as g,
  le as n
};
//# sourceMappingURL=swiper.min-13551361.mjs.map
